/**
 * Map Label Icon Components
 * Shared icons used across map label components
 */

import React from 'react';

/**
 * Zoom Icon - CSS-based, shared between ZoomZone and ClusterBadge
 */
export const ZoomIcon = ({ className }) => (
  <div className={className}>
    <div className={`${className}__bg`} />
    <div className={`${className}__doughnut`} />
    <span className={`${className}__plus`} />
  </div>
);

/**
 * Heart Icon - used for favorite indicators on labels
 * Uses the same SVG path as FavoriteIndicator but rendered as inline HTML
 */
export const HeartIcon = ({ className, isActive = true }) => (
  <svg
    className={`${className} ${isActive ? `${className}--active` : `${className}--inactive`}`}
    viewBox="0 0 15.4 14"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Fill path */}
    <path
      className={`${className}__fill`}
      d="M13.9,1.8c-.8-.9-1.8-1.2-2.9-1.2s-1.6.3-2.3.8c-.3.3-.6.5-.9,1-.3-.3-.5-.7-.9-1-.7-.5-1.5-.8-2.3-.8s-2.2.5-2.9,1.2c-.8.9-1.2,1.9-1.2,3.1s.5,2.4,1.5,3.6c.9,1,2.2,2.2,3.6,3.4.5.4,1,.9,1.7,1.5s.3.2.5.2.4,0,.5-.2c.6-.5,1.2-1,1.7-1.5,1.5-1.2,2.7-2.4,3.6-3.4,1-1.2,1.5-2.3,1.5-3.6s-.4-2.3-1.2-3.1h0Z"
    />
    {/* Stroke/outline path */}
    <path
      className={`${className}__stroke`}
      d="M7.8,13.9c-.3,0-.6-.2-.9-.3-.5-.5-1.2-1-1.7-1.5-1.5-1.2-2.8-2.4-3.7-3.5-1-1.2-1.6-2.5-1.6-3.8S.6,2.3,1.3,1.4C2.8-.2,5.4-.5,7.1.9c.2.2.4.3.6.6.2-.2.4-.4.6-.6,1.8-1.4,4.4-1,5.9.5h0c.9.9,1.2,2.1,1.2,3.4s-.5,2.5-1.6,3.8c-.9,1.1-2.2,2.2-3.7,3.5-.5.4-1,.9-1.7,1.5s-.5.3-.9.3h.2ZM4.5.9c-1,0-1.9.4-2.5,1.1-.7.7-1,1.7-1,2.8s.4,2.2,1.3,3.2s2.1,2.1,3.6,3.3s1,.9,1.7,1.5.3.2.5,0c.6-.5,1.2-1,1.7-1.5,1.5-1.2,2.7-2.3,3.6-3.3.9-1.1,1.3-2.2,1.3-3.2s-.3-2.1-1-2.8h0c-1.2-1.2-3.2-1.6-4.6-.4-.3.2-.5.5-.9.9l-.3.5-.3-.5c-.3-.3-.5-.6-.9-.9-.6-.5-1.2-.7-2-.7h0Z"
    />
  </svg>
);
